import { ArrowRight, CheckCircle, FileText } from 'lucide-react';
import { Dialog, DialogContent } from '../../../../tailwind/dialog';
import { Button } from '../../../../tailwind/button';
import { cn } from '../../../../../lib/utils';
import { formatWalletCurrency } from '../../../../../utils/wallet/walletUtils';
import { waBtn, waSoft } from '../../../../../pages/whatsapp/utils/whatsappUiTokens';

export function WalletRechargeSuccessModal({ open, onOpenChange, transactionDetails, onGoToWallet }) {
  if (!transactionDetails) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-0 overflow-hidden [&>button]:hidden border-0 bg-slate-50 dark:bg-slate-950">
        <div className="bg-[hsl(158,48%,36%)] text-white p-8 flex flex-col items-center justify-center text-center">
          <div className="w-20 h-20 border-2 border-white/80 rounded-lg flex items-center justify-center mb-4 relative shadow-lg bg-[hsl(158,48%,30%)]">
            <span className="font-bold text-2xl tracking-tight">Prodyt</span>
            <div className="absolute -bottom-3 h-7 w-7 bg-[hsl(158,48%,30%)] border-2 border-white/80 rounded-full flex items-center justify-center">
              <CheckCircle className="h-4 w-4 text-white" />
            </div>
          </div>
          <h2 className="text-xl font-bold mt-2">Payment Successful!</h2>
          <p className="text-sm text-white/85 mt-1">Your wallet has been recharged.</p>
        </div>

        <div className="p-6 bg-white dark:bg-slate-900 space-y-6">
          <div className="text-sm text-gray-600 dark:text-gray-300">
            Hi there,
            <br /><br />
            Thank you for recharging your Prodyt Wallet! Your payment has been successfully processed. The credits have been added to your account.
          </div>

          <div className="border border-gray-200 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-950/40 rounded-lg p-5">
            <h3 className="text-sm font-bold text-gray-900 dark:text-white mb-4 border-b border-gray-200 dark:border-slate-800 pb-2">
              Receipt Details
            </h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center text-sm">
                <span className="text-gray-500 dark:text-gray-400">Invoice Number:</span>
                <span className="font-medium text-gray-900 dark:text-white">{transactionDetails.invoiceId}</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-gray-500 dark:text-gray-400">Date Paid:</span>
                <span className="font-medium text-gray-900 dark:text-white">{transactionDetails.date}</span>
              </div>
              <div className="flex justify-between items-center text-sm">
                <span className="text-gray-500 dark:text-gray-400">Type:</span>
                <span className="font-medium text-gray-900 dark:text-white">Wallet Top-up</span>
              </div>
              <div className="pt-3 border-t border-gray-200 dark:border-slate-800 mt-3 space-y-2">
                <div className="flex justify-between items-center text-sm">
                  <span className="text-gray-500 dark:text-gray-400">Amount:</span>
                  <span className="font-medium text-gray-900 dark:text-white">
                    {formatWalletCurrency(transactionDetails.baseAmount, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                  </span>
                </div>
                <div className="flex justify-between items-center text-sm">
                  <span className="text-gray-500 dark:text-gray-400">GST (18%):</span>
                  <span className="font-medium text-gray-900 dark:text-white">
                    {formatWalletCurrency(transactionDetails.gstAmount, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                  </span>
                </div>
              </div>
              <div className="pt-3 border-t border-gray-200 dark:border-slate-700 mt-3 flex justify-between items-center">
                <span className="font-bold text-gray-900 dark:text-white">Total Paid:</span>
                <span className={cn('font-bold', waSoft.text)}>
                  {formatWalletCurrency(transactionDetails.total, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                </span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 pt-2">
            <Button className={cn(waBtn.primary, 'w-full font-medium')} onClick={onGoToWallet}>
              Go to Wallet <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            <Button variant="outline" className={cn(waBtn.secondary, 'w-full font-medium')}>
              <FileText className={cn('mr-2 h-4 w-4', waSoft.text)} />
              Download Invoice
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
